import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { Reveal } from './Reveal';
import { VignetteFrame } from './VignetteFrame';
import { CountUp } from './CountUp';
interface AccountabilityDashboardProps {
  compact?: boolean;
}
const agents: {
  name: string;
  avg: string;
  booked: number;
  fill: number;
}[] = [{
  name: 'Jordan',
  avg: '0:38',
  booked: 9,
  fill: 100
}, {
  name: 'Sam',
  avg: '0:44',
  booked: 8,
  fill: 88
}, {
  name: 'Priya',
  avg: '0:41',
  booked: 7,
  fill: 78
}];
export function AccountabilityDashboard({
  compact = false
}: AccountabilityDashboardProps) {
  const reduceMotion = useReducedMotion();
  return <VignetteFrame label="Weekly response report" timestamp="Demo data" data-id="element-222" data-mp="wlko4z0rmsam">
      <dl className={`grid gap-3 ${compact ? 'grid-cols-2' : 'grid-cols-2 sm:grid-cols-4'}`} data-id="element-223" data-mp="11k5msu0dd3wy">
        <div className="rounded-lg border border-white/10 bg-ink-700 p-4" data-id="element-224" data-mp="2qzc22aq4nybv">
          <dt className="text-[11px] uppercase tracking-[0.1em] text-white/40" data-id="element-225" data-mp="2vxdmayzai3ox">
            Avg response
          </dt>
          <dd className="mt-2 font-display text-xl font-bold text-brand" data-id="element-226" data-mp="e8tijoy1l3t0">0:41</dd>
        </div>
        <div className="rounded-lg border border-white/10 bg-ink-700 p-4" data-id="element-227" data-mp="9a015lfmwsnk">
          <dt className="text-[11px] uppercase tracking-[0.1em] text-white/40" data-id="element-228" data-mp="o0fop6viwcow">
            Leads answered
          </dt>
          <dd className="mt-2 font-display text-xl font-bold text-brand" data-id="element-229" data-mp="j1w69gg51j1a">
            <CountUp value={118} data-id="element-230" data-mp="3rg4qo18ib3id" />
            /118
          </dd>
        </div>
        <div className="rounded-lg border border-white/10 bg-ink-700 p-4" data-id="element-231" data-mp="3mhjp9yhiqdsc">
          <dt className="text-[11px] uppercase tracking-[0.1em] text-white/40" data-id="element-232" data-mp="3mjo255xean4r">
            Appointments
          </dt>
          <dd className="mt-2 font-display text-xl font-bold text-brand" data-id="element-233" data-mp="ad0j1uqbqvk">
            <CountUp value={24} data-id="element-234" data-mp="9211e8bh5a9" />
          </dd>
        </div>
        <div className="rounded-lg border border-white/10 bg-ink-700 p-4" data-id="element-235" data-mp="1fq2eedc9qtkb">
          <dt className="text-[11px] uppercase tracking-[0.1em] text-white/40" data-id="element-236" data-mp="1bps6uw8tvv3c">
            Unsigned agreements
          </dt>
          <dd className="mt-2 font-display text-xl font-bold text-brand" data-id="element-237" data-mp="8djj88vi7d4v">0</dd>
        </div>
      </dl>

      <ul className="mt-5 space-y-4 border-t border-white/10 pt-5" data-id="element-238" data-mp="dcmkdi8d4z7k">
        {agents.map((agent, index) => <li key={agent.name} data-id="element-239" data-mp="idadc9g5jq4f" data-mpi={index}>
            <Reveal delay={0.08 * index} offset={8} data-id="element-240" data-mp="iaxyw69lrxw4">
              <div className="flex items-baseline justify-between gap-4" data-id="element-241" data-mp="md2p0v0uece0">
                <span className="text-sm font-medium text-white/80" data-id="element-242" data-mp="3lu0xds8kk3p4">{agent.name}</span>
                <span className="text-xs tabular-nums text-white/50" data-id="element-243" data-mp="3qsc8056oui8e">
                  {agent.avg} avg | {agent.booked} booked
                </span>
              </div>
              <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-white/[0.06]" data-id="element-244" data-mp="3us2x84gkgqat">
                <motion.div className="h-full rounded-full bg-brand" style={{
              willChange: 'transform',
              originX: 0
            }} initial={reduceMotion ? {
              scaleX: agent.fill / 100
            } : {
              scaleX: 0
            }} whileInView={{
              scaleX: agent.fill / 100
            }} viewport={{
              once: true,
              amount: 0.4
            }} transition={{
              duration: 0.7,
              delay: reduceMotion ? 0 : 0.12 * index,
              ease: [0.22, 1, 0.36, 1]
            }} data-id="element-245" data-mp="3hmc8t64rj4r" />
              </div>
            </Reveal>
          </li>)}
      </ul>
    </VignetteFrame>;
}